export const getParsedValue = <T>(value: string): T | null => {
  try {
    return JSON.parse(value);
  } catch (e) {
    return value as unknown as T;
  }
};
